/**
 * Makes a password an admin can hand over: strong, but readable enough to say
 * aloud or retype. No characters that get confused for each other (0/O, 1/l/I),
 * and grouped so the eye can keep its place.
 */
const ALPHABET = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";

export function generatePassword({ groups = 4, size = 4 } = {}) {
  const bytes = new Uint32Array(groups * size);
  crypto.getRandomValues(bytes);

  const chars = Array.from(bytes, (n) => ALPHABET[n % ALPHABET.length]);
  return Array.from({ length: groups }, (_, g) => chars.slice(g * size, (g + 1) * size).join("")).join("-");
}

/** The block of text an admin pastes into an email or hands over on paper. */
export const signInDetails = ({ address, email, password }) =>
  [`App Hub`, ``, `Address:  ${address}`, `Email:    ${email}`, `Password: ${password}`].join("\n");
